import type { SlotPlanInfo } from '@@partner:types:app'

import React, { useState } from 'react'
import { mergeLeft } from 'merge-left-utils'
import {
  representTimeWithDateObject,
  convertDateObjectToSeconds
} from '@@partner:helpers/date-utils'

import { Form, InputNumber, Button } from 'rsuite'
import TimePicker from '@components/common/TimePicker'

const INITIAL_FORM_DATA: SlotPlanInfo = {
  id: undefined,
  slotStartTime: 0,
  slotFinishTime: 0,
  ordersLimit: 0,
  positionsLimit: 0,
  weekDay: 0,
  slotTimeout: 0
}

export interface SlotTableFormProps {
  value?: SlotPlanInfo
  onUpdate: (slot: SlotPlanInfo) => void
}

export default function SlotTableForm ({
  value = INITIAL_FORM_DATA,
  onUpdate
}: SlotTableFormProps) {
  const [ formState, setFormState ] = useState(
    mergeLeft(INITIAL_FORM_DATA, value)
  )

  const makeTimeChangeHandler = (field: string) => (date: number) => {
    setFormState((state) =>
      mergeLeft(state, { [field]: date })
    )
  }

  const makeInputChangeHandler = (field: string) => (value: any) => {
    setFormState((state) => mergeLeft(state, { [field]: value }))
  }

  const handleSubmit = () => {
    onUpdate(formState)
    setFormState(INITIAL_FORM_DATA)
  }

  return (
    <div className="mt-4">
      <span className="block my-2">Добавить слот</span>
      <Form.Group className="ShopForm__Slots__Add">
        <span className="text-xs">Время слота</span>
        <TimePicker
          value={representTimeWithDateObject(formState.slotStartTime)}
          onSelect={makeTimeChangeHandler('slotStartTime')}
        />
        <span>-</span>
        <TimePicker
          value={representTimeWithDateObject(formState.slotFinishTime)}
          onSelect={makeTimeChangeHandler('slotFinishTime')}
        />

        <span className="text-xs">Максимум заказов</span>
        <InputNumber
          style={{ marginLeft: '15px', width: '200px' }}
          min={0}
          step={1}
          placeholder="Максимум заказов"
          value={formState.ordersLimit}
          onChange={makeInputChangeHandler('ordersLimit')}
        />
        <span className="text-xs">Максимум позиций</span>
        <InputNumber
          style={{ marginLeft: '15px', width: '200px' }}
          min={0}
          step={1}
          placeholder="Максимум позиций"
          value={formState.positionsLimit}
          onChange={makeInputChangeHandler('positionsLimit')}
        />
        <span className="text-xs">Таймаут слота (минуты)</span>
        <InputNumber
          style={{ marginLeft: '15px', width: '200px' }}
          min={0}
          step={1}
          placeholder="Таймаут слота (в минутах)"
          value={formState.slotTimeout}
          onChange={makeInputChangeHandler('slotTimeout')}
        />
        <Button
          size="md"
          appearance="primary"
          style={{ height: '36px', marginLeft: '15px', minWidth: '120px' }}
          color="green"
          onClick={handleSubmit}
        >
          Добавить
        </Button>
      </Form.Group>
    </div>
  )
}
